__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "mfe-root";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.11.4", () => (Promise.all([__webpack_require__.e(513), __webpack_require__.e(326)]).then(() => (() => (__webpack_require__(326))))));
			register("@emotion/styled", "11.11.5", () => (Promise.all([__webpack_require__.e(903), __webpack_require__.e(373)]).then(() => (() => (__webpack_require__(5903))))));
			register("@grupoboticario/conecta-core-react-components", "1.0.11", () => (__webpack_require__.e(544).then(() => (() => (__webpack_require__(7544))))));
			register("@grupoboticario/flora-react-icons", "29.11.4", () => (() => (__webpack_require__(3982))), 1);
			register("@grupoboticario/flora-react", "1.16.2", () => (() => (__webpack_require__(4670))), 1);
			register("@grupoboticario/flora", "1.27.4", () => (() => (__webpack_require__(3678))), 1);
			register("@mui/material", "5.15.19", () => (Promise.all([__webpack_require__.e(513), __webpack_require__.e(436), __webpack_require__.e(373), __webpack_require__.e(821)]).then(() => (() => (__webpack_require__(4436))))));
			register("js-sha256", "0.11.0", () => (__webpack_require__.e(813).then(() => (() => (__webpack_require__(5813))))));
			register("jwt-decode", "4.0.0", () => (__webpack_require__.e(420).then(() => (() => (__webpack_require__(4420))))));
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(7950))), 1);
			register("react-router-dom", "5.3.4", () => (() => (__webpack_require__(5921))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(5043))), 1);
			initExternal(7853);
			initExternal(6474);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};